{
  "version": 1,
  "asset_id": "db190f1d-a6fd-4ded-8cc5-a3fc2399c222",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/db190f1d-a6fd-4ded-8cc5-a3fc2399c222/sigma.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/db190f1d-a6fd-4ded-8cc5-a3fc2399c222/sigma.png",
  "original_filename": "sigma.png",
  "size": 17319,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:51:09Z"
}
